import { API, generic } from "api"

export default class NotesService {
  static index = async ({ pageState, courseId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_PAPERS_INDEX_STATUS",
      stateDataKey: ["papers", "course"],
      stateErrorKey: ["paperErrors", "courseErrors"],
      apiEndpoint: API.students.courses.papers.index, //Should be called API.students.papers.index
      apiUrlReplacements: { courseId },
      apiData: {},
      errorMessage: "Papers could not be fetched"
    })
  }

  static show = async ({ pageState, subjectId, paperId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_PAPERS_SHOW_STATUS",
      stateDataKey: [
        "paper",
        "course",
        "subject",
        "paper_attempt",
        "course_subscription"
      ],
      stateErrorKey: [
        "paperErrors",
        "courseErrors",
        "subjectErrors",
        "paperAttemptErrors",
        "courseSubscriptionErrors"
      ],
      apiEndpoint: API.students.papers.show,
      apiUrlReplacements: { subjectId, paperId },
      apiData: {},
      errorMessage: "Paper could not be fetched"
    })
  }

  static evaluation = async ({ pageState, paperId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_PAPERS_EVALUATION_STATUS",
      stateDataKey: ["paper", "paper_attempt"],
      stateErrorKey: ["paperErrors", "paperAttemptErrors"],
      apiEndpoint: API.students.papers.evaluation,
      apiUrlReplacements: { paperId },
      apiData: {},
      errorMessage: "Paper could not be fetched"
    })
  }
}
